import { USER_STATUS, USER_FORGOT_DETAILS, USER_GET_OTP, USER_VERIFY_OTP, USER_UPDATE_IRCTC_ID } from '../../../../constants/ActionTypes';

const INITIAL_STATE = {
  userStatus: {},
  forgotDetails: {},
  getOtpResponse: {},
  verifyOtpResponse: {},
  irctcId: '',
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case USER_STATUS: {
    return {
      ...state,
      userStatus: action.payload.userStatus,
    };
  }
  case USER_FORGOT_DETAILS: {
    return {
      ...state,
      forgotDetails: action.payload.userDetails,
    };
  }
  case USER_UPDATE_IRCTC_ID: {
    return {
      ...state,
      irctcId: action.payload
    }
  }
  case USER_GET_OTP: {
    return {
      ...state,
      getOtpResponse: action.payload.getOtpResponse,
    };
  }
  case USER_VERIFY_OTP: {
    return {
      ...state,
      verifyOtpResponse: action.payload.verifyOtpResponse,
    };
  }
  default:
    return state;
  }
};
